module.exports = __webpack_public_path__ + "img/BTL_sRGB_2023_Winter-Warmers_Parmigiana_Macro.9b5dfe3b.png";